module.exports = __webpack_public_path__ + "static/media/55.7ad339f3.JPG";